import { useRuntimeTranslation } from "../../../../hooks/useLoadI18nNamespaces";
import { MARKETPLACE_V3_LOCALIZATION_NAMESPACES } from "../../../../methods/getRouteLocalizationNamespaces";

const useMarketplaceV3Translation = () => useRuntimeTranslation(MARKETPLACE_V3_LOCALIZATION_NAMESPACES);

export default useMarketplaceV3Translation;
